import React, { useState } from "react";
import { ShoppingBag } from "lucide-react";

export function ProductImage({ src, alt = "", className = "", iconSize = 22 }) {
  const [err, setErr] = useState(false);
  if (!src || err) {
    return (
      <div className={`${className} flex items-center justify-center bg-[#DDF0E5]`} data-testid="product-image-placeholder">
        <ShoppingBag className="text-[#0B7A3B]/45" size={iconSize} />
      </div>
    );
  }
  return <img src={src} alt={alt} className={className} loading="lazy" onError={() => setErr(true)} />;
}
